import React from "react";
import { Link } from "react-router-dom";

// dotConverse brand mark. Single shared component used in Navigation, Footer,
// and Admin header. `dark` flips the wordmark to white for dark surfaces.

export default function Logo({
  dark = false,
  height = 28,
  to = "/",
  className = "",
  testId = "brand-logo",
  asLink = true,
}) {
  const img = (
    <img
      src="/dotconverse-logo.png"
      alt="dotConverse"
      data-testid={testId}
      style={{
        height: `${height}px`,
        width: "auto",
        display: "block",
        // Dark variant: turn the whole wordmark white. The colorful "o" loses
        // saturation here — acceptable trade for clean dark-surface contrast.
        filter: dark ? "brightness(0) invert(1)" : "none",
      }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );

  if (!asLink) return img;

  return (
    <Link to={to} aria-label="dotConverse — home" className="inline-flex items-center group">
      {img}
    </Link>
  );
}
